export const createConditionAction = () => {
    return {};
};

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return ["refUserReport"].includes(field?.key);
            },
            visibleField: ({ props }) => {
                const { isShowReportSelect } = props;
                return isShowReportSelect === true || isShowReportSelect === "true";
            },
        },
    ];
};
